$(function(){
    if($('.applicationFormRows').length){
        checkIsFileUploaded();
    }

    if($('#waitUntilFileIsScanned').length){
        counter = 0;
        startAnalyzingProcess($('#waitUntilFileIsScanned').data('sessionkey'),
            $('#waitUntilFileIsScanned').data('file'),
            $('#waitUntilFileIsScanned').data('sid'));
    }
});

function startAnalyzingProcess(sessionKey, file, sid) {
    $.ajax({
        type: 'POST',
        url: '/application/applicantRegisterCvAnalyzerGenerator/analyzeFile/',
        data: {
            script: 'cvAnalyzation',
            action: 'startAnalyzation',
            sessionkey: sessionKey,
            fileToAnalyze: file
        },
        success: function (data) {
            tk_test(sessionKey, file, sid);
        }
    });
}

function tk_test(sessionKey, filename, sid) {
    var page_lang = getUrlVars()["page_lang"];
    $.ajax({
        type: 'POST',
        url: '/application/applicantRegisterCvAnalyzerGenerator/analyzeFile?page_lang=' + page_lang,
        data: {
            script: 'cvAnalyzation',
            action: 'checkAnalyzation',
            sessionkey: sessionKey,
            fileToAnalyze: filename
        },
        success: function (data) {
            if (data.change === 1 || counter++ === 10) {
                window.location.href = '/job/apply/' + sid + '?sessionkey=' + sessionKey + '&cvAnalyzer=1&page_lang=' + page_lang;
            } else {
                setTimeout(function () {
                    tk_test(sessionKey, filename, sid);
                }, 1000);
            }
        }
    });
}

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m,key,value) {
        vars[key] = value;
    });
    return vars;
}

function checkIsFileUploaded(){
    setInterval(function(){
        if ($('.list-group-item').length && !$('.list-group-item i').hasClass('eii--fa6-solid--ban')){
            $("#submit-button").click();
            $("#submit-button").remove();
        }
    }, 100);
}

